/**
 * Lee la duración de un audio desde una URL probando solo el header
 * (`preload='metadata'`).
 * Devuelve la duración en milisegundos. Rechaza si el audio no carga o no
 * expone una duración válida.
 */
export const resolveAudioDuration = (audioUrl: string): Promise<number> =>
  new Promise((resolve, reject) => {
    const audio = new Audio();
    audio.preload = 'metadata';
    audio.addEventListener('loadedmetadata', () => {
      if (isFinite(audio.duration) && audio.duration > 0) {
        resolve(Math.round(audio.duration * 1000));
      } else {
        reject(new Error('Audio metadata sin duración válida'));
      }
    });
    audio.addEventListener('error', () => {
      reject(new Error(`No se pudo cargar metadata de ${audioUrl}`));
    });
    audio.src = audioUrl;
  });
